import { render, staticRenderFns } from "./freezerMsgPartStatistics.vue?vue&type=template&id=3fb61fab"
import script from "./freezerMsgPartStatistics.vue?vue&type=script&lang=js"
export * from "./freezerMsgPartStatistics.vue?vue&type=script&lang=js"
import style0 from "./freezerMsgPartStatistics.vue?vue&type=style&index=0&id=3fb61fab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports